export default {
    getNumberDecimalValue(number) {
        let value = 0
        if(!isNaN(number) && number !== null && number !== '') {
            value = parseFloat(number)
        }

        return value
    },
}